'use strict';

let routes = function ($stateProvider, baseState) {

    $stateProvider

        .state('' + baseState + '.transactions', {
            abstract: true,
            url: "/transactions",
            template: require("./inspect.transactions.html"),
        })

        .state('' + baseState + '.transactions.tax-entities', {
            url: "/tax-entities",
            template: require("./inspect.transactions.tax-entities.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.transactions.accounts', {
            url: "/accounts",
            template: require("./inspect.transactions.accounts.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.transactions.account-balances', {
            url: "/account-balances",
            template: require("./inspect.transactions.account-balances.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.transactions.transactions', {
            url: "/transactions",
            template: require("./inspect.transactions.transactions.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.transactions.transactions.curate', {
            abstract: true,
            url: "/curate-and-classify",
            template: require("crud/clerk-transaction-row/curate-and-classify.html"),
            data: {pageTitle: 'Curate Transaction Rows'}
        })

        .state('' + baseState + '.transactions.transactions.curate.transactions', {
            abstract: true,
            url: "/transactions",
            template: "<ui-view/>"
        })

        .state('' + baseState + '.transactions.transactions.curate.transactions.transactions', {
            abstract: true,
            url: "/transactions",
            template: "<ui-view/>"
        });

    let views = {};
    views['@' + baseState + '.clerk-ledger-entry-rows'] = {
        template: require("crud/clerk-ledger-entry-row/list.html"),
        controller: "listClerkLedgerEntryRowsController",
    };
    views['curateStepControls@' + baseState + '.transactions.transactions.curate'] = {
        templateProvider: /*@ngInject*/ function ($stateParams) {
            console.log('templateUrl function @', $stateParams);
            switch ($stateParams.curateStep) {
                case "assign-sending-and-receiving-parties":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.assign-sending-and-receiving-parties.html");
                    break;
                case "assign-sending-and-receiving-parties-one-by-one":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.assign-sending-and-receiving-parties-one-by-one.html");
                    break;
                case "calculate-vat-amounts":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.calculate-vat-amounts.html");
                    break;
                case "expense-report-contents":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.expense-report-contents.html");
                    break;
                case "fine-tune-ledger-accounts":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.fine-tune-ledger-accounts.html");
                    break;
                case "import":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.import.html");
                    break;
                case "ledger-entry-types":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.ledger-entry-types.html");
                    break;
                case "ledger-entry-types-one-by-one":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.ledger-entry-types-one-by-one.html");
                    break;
                case "map-invoice-related-transactions":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.map-invoice-related-transactions.html");
                    break;
                case "parse-imported":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.parse-imported.html");
                    break;
                case "reality-check":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.reality-check.html");
                    break;
                case "supporting-documents":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.supporting-documents.html");
                    break;
                case "up-to-date-and-complete":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.up-to-date-and-complete.html");
                    break;
                case "whereabouts":
                    return require("crud/clerk-transaction-row/curate-steps/transactions.transactions.whereabouts.html");
                    break;
            }
        },
    };
    /*
     TODO: Restore current classification / item logic but then via components instead of this madness

     views['currentClassificationForm@' + baseState + '.transactions.transactions.curate'] = {
     controller: "currentClerkTransactionRowClassificationController",
     template: require("crud/clerk-transaction-row/current-classification-form.html"),
     };
     views['curateSection@' + baseState + '.transactions.transactions.curate'] = {
     controller: "listClerkTransactionRowsController",
     template: require("crud/clerk-transaction-row/curate.html"),
     };
     views['currentClassificationStep@' + baseState + '.transactions.transactions.curate.transactions.transactions.by-curate-step'] = {
     controller: /*@ngInject* / function (routeBasedContentFilters) {
     this.uiOnParamsChanged = function (changedParams, $transition$) {
     // Note: This is not triggered until this view is actually rendered to the DOM
     console.log('routes.uiOnParamsChanged - transactions.transactions.curate.transactions.transactions.by-curate-step', changedParams, $transition$);
     if (changedParams.activeClerkTransactionRowId) {
     routeBasedContentFilters.ClerkLedgerEntry_stemming_from_clerk_transaction_row_id = changedParams.activeClerkTransactionRowId;
     routeBasedContentFilters.ClerkLedgerEntryRow_ClerkLedgerEntry_stemming_from_clerk_transaction_row_id = changedParams.activeClerkTransactionRowId;
     }
     };
     },
     templateProvider: /*@ngInject* / function ($stateParams) {
     console.log('templateUrl function currentClassificationStep@', $stateParams);
     switch ($stateParams.curateStep) {
     case "assign-sending-and-receiving-parties":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.assign-sending-and-receiving-parties.html");
     break;
     case "assign-sending-and-receiving-parties-one-by-one":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.assign-sending-and-receiving-parties-one-by-one.html");
     break;
     case "calculate-vat-amounts":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.calculate-vat-amounts.html");
     break;
     case "expense-report-contents":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.expense-report-contents.html");
     break;
     case "fine-tune-ledger-accounts":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.fine-tune-ledger-accounts.html");
     break;
     case "import":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.import.html");
     break;
     case "ledger-entry-types":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.ledger-entry-types.html");
     break;
     case "ledger-entry-types-one-by-one":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.ledger-entry-types-one-by-one.html");
     break;
     case "map-invoice-related-transactions":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.map-invoice-related-transactions.html");
     break;
     case "parse-imported":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.parse-imported.html");
     break;
     case "reality-check":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.reality-check.html");
     break;
     case "supporting-documents":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.supporting-documents.html");
     break;
     case "up-to-date-and-complete":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.up-to-date-and-complete.html");
     break;
     case "whereabouts":
     return require("crud/clerk-transaction-row/classification-steps/transactions.transactions.whereabouts.html");
     break;
     }
     },
     };
     */

    /*

     // "Supporting-documents"
     .state('' + baseState + '.clerk-transaction-rows.curate.transactions.transactions.supporting-documents', {
     url: "/supporting-documents",
     data: {
     pageTitle: 'Curate Transaction Row - Step \'transactions.transactions.supporting-documents\'',
     stepCaption: "Supporting-documents",
     stepMetadata: {"stepReference":"transactions.transactions.supporting-documents","step":"supporting-documents","stepAttributes":["date","amount","is_this_a_transaction_between_your_or_your_companies_accounts","is_this_a_transaction_within_the_accounts_of_a_single_tax_entity","are_you_or_one_of_your_companies_receiving_money","are_you_or_one_of_your_companies_sending_money","receiving_party_do_you_know_the_sending_party_well","sending_party_do_you_know_the_receiving_party_well","symmetricClerkTransactionRow","fromClerkAccount","toClerkAccount","raw_info_main","semantic_annotation","is_this_paying_an_invoice","paysClerkInvoice","ignore_receiving_party_since_already_handled_by_symmetric_ctr","receivingPartyClerkTaxEntity","ignore_sending_party_since_already_handled_by_symmetric_ctr","sendingPartyClerkTaxEntity","sending_receiving_party_clerk_tax_entities_guess_last_attempted"]},
     },
     template: require("crud/clerk-transaction-row/curate-steps/transactions.transactions.supporting-documents.html"),
     controller: "listClerkTransactionRowsController",
     resolve: {
     setRouteBasedVisibilitySettingsLevel0: /*@ngInject* / function (routeBasedVisibilitySettings, $stateParams) {
     routeBasedVisibilitySettings.ClerkTransactionRow_columns_by_step = 'transactions.transactions.supporting-documents';
     },
     }
     })

     // "Supporting-documents"
     .state('' + baseState + '.clerk-transaction-rows.existing.edit.transactions.transactions.supporting-documents', {
     url: "/supporting-documents",
     template: require("crud/clerk-transaction-row/steps/transactions.transactions.supporting-documents.html"),
     data: {
     pageTitle: 'Edit Transaction Row - Step \'transactions.transactions.supporting-documents\'',
     stepCaption: "Supporting-documents",
     stepMetadata: {"stepReference":"transactions.transactions.supporting-documents","step":"supporting-documents","stepAttributes":["date","amount","is_this_a_transaction_between_your_or_your_companies_accounts","is_this_a_transaction_within_the_accounts_of_a_single_tax_entity","are_you_or_one_of_your_companies_receiving_money","are_you_or_one_of_your_companies_sending_money","receiving_party_do_you_know_the_sending_party_well","sending_party_do_you_know_the_receiving_party_well","symmetricClerkTransactionRow","fromClerkAccount","toClerkAccount","raw_info_main","semantic_annotation","is_this_paying_an_invoice","paysClerkInvoice","ignore_receiving_party_since_already_handled_by_symmetric_ctr","receivingPartyClerkTaxEntity","ignore_sending_party_since_already_handled_by_symmetric_ctr","sendingPartyClerkTaxEntity","sending_receiving_party_clerk_tax_entities_guess_last_attempted"]},
     }
     })

     */

    $stateProvider

    // Curate-steps
        .state('' + baseState + '.transactions.transactions.curate.transactions.transactions.by-curate-step', {
            url: "/:curateStep/:activeClerkTransactionRowId?"
            + "cf_ClerkTransactionRow_page?"
            + "&cf_ClerkTransactionRow_order?"
            + "&cf_ClerkTransactionRow_from_date?"
            + "&cf_ClerkTransactionRow_to_date?"
            + "&cf_ClerkTransactionRow_from_clerk_account_id?"
            + "&cf_ClerkTransactionRow_to_clerk_account_id?"
            + "&cf_ClerkTransactionRow_from_or_to_clerk_account_id?"
            + "&cf_ClerkTransactionRow_FromOrToClerkAccount_clerk_tax_entity_id?"
            + "&cf_ClerkTransactionRow_max_abs_amount?"
            + "&cf_ClerkTransactionRow_min_abs_amount?"
            + "&cf_ClerkTransactionRow_receiving_party_clerk_tax_entity_id?"
            + "&cf_ClerkTransactionRow_sending_party_clerk_tax_entity_id?"
            + "&cf_ClerkTransactionRow_receiving_or_sending_party_clerk_tax_entity_id?"
            + "&cf_ClerkTransactionRow_ledger_relevant_for_clerk_tax_entity_id?"
            + "&cf_ClerkTransactionRow_receiving_party_clerk_ledger_entry_type_id?"
            + "&cf_ClerkTransactionRow_sending_party_clerk_ledger_entry_type_id?"
            + "&cf_ClerkTransactionRow_receiving_or_sending_party_clerk_ledger_entry_type_id?"
            + "&cf_ClerkTransactionRow_pays_clerk_invoice_id?"
            + "&cf_ClerkTransactionRow_pays_clerk_trip_id?"
            + "&cf_ClerkTransactionRow_part_of_clerk_travel_claim_id?"
            /*
            Not triggerable by state params, only route params
            + "&cf_ClerkTransactionRow_hide_split_parents?"
            + "&ClerkTransactionRow_hide_split_children?"
            */
            + "&cf_ClerkTransactionRow_split_parent_clerk_transaction_row_id?"
            + "&cf_ClerkTransactionRow_split_family_of_clerk_transaction_row_id?"
            + "&cf_ClerkTransactionRow_personal_empire_perspective_clerk_in_out_neither_category_id?"
            + "&cf_ClerkTransactionRow_sending_or_receiving_party_perspective_clerk_in_out_neither_category_id?"
            + "&cf_ClerkTransactionRow_supporting_documents_not_deemed_good_enough?"
            + "",
            params: {
                curateStep: {dynamic: false},
                cf_ClerkTransactionRow_page: {value: '1', dynamic: true},
                cf_ClerkTransactionRow_order: {value: null, dynamic: true},
                cf_ClerkTransactionRow_from_date: {value: null, dynamic: true},
                cf_ClerkTransactionRow_to_date: {value: null, dynamic: true},
                cf_ClerkTransactionRow_from_clerk_account_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_to_clerk_account_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_from_or_to_clerk_account_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_FromOrToClerkAccount_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_max_abs_amount: {value: null, dynamic: true},
                cf_ClerkTransactionRow_min_abs_amount: {value: null, dynamic: true},
                cf_ClerkTransactionRow_receiving_party_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_sending_party_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_receiving_or_sending_party_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_ledger_relevant_for_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_receiving_party_clerk_ledger_entry_type_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_sending_party_clerk_ledger_entry_type_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_receiving_or_sending_party_clerk_ledger_entry_type_id: {
                    value: null,
                    dynamic: true
                },
                cf_ClerkTransactionRow_pays_clerk_invoice_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_pays_clerk_trip_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_part_of_clerk_travel_claim_id: {value: null, dynamic: true},
                /*
                Not triggerable by state params, only route params
                cf_ClerkTransactionRow_hide_split_parents: {value: null, dynamic: true},
                ClerkTransactionRow_hide_split_children: {value: null, dynamic: true},
                */
                cf_ClerkTransactionRow_split_parent_clerk_transaction_row_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_split_family_of_clerk_transaction_row_id: {value: null, dynamic: true},
                cf_ClerkTransactionRow_personal_empire_perspective_clerk_in_out_neither_category_id: {
                    value: null,
                    dynamic: true
                },
                cf_ClerkTransactionRow_sending_or_receiving_party_perspective_clerk_in_out_neither_category_id: {
                    value: null,
                    dynamic: true
                },
                cf_ClerkTransactionRow_supporting_documents_not_deemed_good_enough: {value: null, dynamic: true},
                activeClerkTransactionRowId: {value: null, dynamic: false}
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkTransactionRow_columns_by_step = 'transactions.transactions.' + $stateParams.curateStep;
                    routeBasedVisibilitySettings.ClerkAccountBalance_columns_by_step = 'transactions.transactions.' + $stateParams.curateStep;
                },
                setRouteBasedContentFiltersLevel1: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel0, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_stemming_from_clerk_transaction_row_id = $stateParams.activeClerkTransactionRowId;
                    routeBasedContentFilters.ClerkLedgerEntryRow_ClerkLedgerEntry_stemming_from_clerk_transaction_row_id = $stateParams.activeClerkTransactionRowId;
                },
                currentClerkTransactionRow: /*@ngInject*/ function (dataEnvironmentParam, $stateParams, clerkTransactionRow) {
                    var clerkTransactionRowId = $stateParams.activeClerkTransactionRowId === 'all' ? null : $stateParams.activeClerkTransactionRowId;
                    if (clerkTransactionRowId) {
                        clerkTransactionRow.$activate();
                        return clerkTransactionRow.load($stateParams.activeClerkTransactionRowId);
                    } else {
                        return null;
                    }
                },
            },
            views: views,
        });

    /*
     .state('' + baseState + '.optionally-by-clerk-ledger-deliverable.inspect.transactions.tax-regions', {
     url: "/tax-regions",
     onEnter: function () {
     },
     data: {pageTitle: 'Inspect'}
     })
     */

};

let loadRoutesLazily = function ($stateProvider, baseState) {

    let lazyStateProvider = {
        states: [],
        state: function (name, stateConfig) {
            let state = angular.merge({name: name}, stateConfig);
            this.states.push(state);
            return this;
        }
    };
    routes(lazyStateProvider, baseState);
    $stateProvider.state(baseState + '.transactions.**', {
        url: "/transactions",
        lazyLoad: function ($transition$, ParentService) {
            return lazyStateProvider;
        },
    });

};

export default {
    routes: routes,
    loadRoutesLazily: loadRoutesLazily,
};



// WEBPACK FOOTER //
// .-dna/app/subsections/money-movements/money-movements.js